import { useEffect, useState } from 'react';

// Single shared "viewport is narrow" hook. Used by the Builder layout to
// collapse its 3-column desktop arrangement into a stacked mobile flow.
// Default breakpoint is 760px — wider than typical "phone" (640px) because
// the Builder needs real horizontal real estate even on tablets.
export function useIsMobile(breakpointPx = 760): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpointPx;
  });
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpointPx - 1}px)`);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [breakpointPx]);
  return isMobile;
}
